import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import CommentApprovalComponent from './CommentApprovalComponent';

import {
  confirmDeleteComment,
  getPostById,
  getPostCommentsList,
  updateCommentStatus,
} from '../actions';

import { ALL_COMMENTS, PENDING_COMMENTS } from './constants';

import * as communitySelectors from '../selectors';

const CommentApprovalContainer = ({ post }) => {
  const { commentsRequireApproval, id: postId, pendingComments } = post;

  const [status, setStatus] = useState(
    pendingComments?.length ? null : PENDING_COMMENTS,
  );

  const dispatch = useDispatch();
  const comments = useSelector((state) =>
    communitySelectors.getPostCommentsList(state, {
      currentPostId: postId,
      defaultValue: [],
    }),
  );

  const loadComments = () => {
    getPostCommentsList(dispatch, postId, {
      disable_pagination: true,
      status,
    });
  };

  useEffect(() => {
    if (!status) return;
    if (!commentsRequireApproval && status === PENDING_COMMENTS) return;
    loadComments();
  }, [status]);

  const onUpdateCommentStatus = async (id, data) => {
    const isUpdated = await updateCommentStatus(dispatch, id, data);
    if (!isUpdated) return;
    setStatus(PENDING_COMMENTS);
    getPostById(dispatch, postId);
    loadComments();
  };

  const removeComment = (commentId) => {
    confirmDeleteComment(dispatch, postId, commentId);
  };

  const shownComments =
    pendingComments?.length && !status ? pendingComments : comments;

  return (
    <Box>
      <CommentApprovalComponent
        commentsRequireApproval={commentsRequireApproval}
        comments={shownComments}
        updateCommentStatus={onUpdateCommentStatus}
        removeComment={removeComment}
        setStatus={setStatus}
        isShowAllComments={status === ALL_COMMENTS}
      />
    </Box>
  );
};

CommentApprovalContainer.propTypes = {
  post: PropTypes.instanceOf(Object).isRequired,
};

export default CommentApprovalContainer;
